import "./statistics.sass";
import { useEffect, useState, useMemo } from "react";
import { getStats, transformStatsData } from "../../../../services/minute-a-minute/getStats";
import { useAutoRefresh } from "../../hooks/useAutoRefresh";
import { normalizeStatistics } from "./statisticsHelpers";
import StatisticRow from "./StatisticRow";
import Loading from "../../../loading/loading";

export default function Statistics({ matchId = null, statisticsConfig = [], matchData, refresh = false, country = null }) {
  const [statsData, setStatsData] = useState(null);
  const [loading, setLoading] = useState(!!matchId);
  const [error, setError] = useState(null);

  // Función para obtener datos con o sin loading
  const fetchStatsData = async (showLoading = true) => {
    if (!matchId) {
      setError("No se proporcionó el ID del partido");
      setLoading(false);
      return;
    }

    try {
      if (showLoading) setLoading(true);

      const rawData = await getStats(matchId, country);
      const transformed = transformStatsData(rawData);
      
      setStatsData(transformed);
      setError(null);
    } catch (err) {
      console.error("Error cargando estadísticas:", err);
      setError(err.message || "Error cargando estadísticas");
    } finally {
      if (showLoading) setLoading(false);
    }
  };

  // Usar hook de auto-refresh si refresh es true
  useAutoRefresh(refresh, fetchStatsData, [matchId, refresh, country]);

  // Cargar datos iniciales si refresh es false
  useEffect(() => {
    if (!refresh) {
      fetchStatsData(true);
    }
  }, [matchId, refresh, country]);

  // Calcular estadísticas normalizadas para visualización
  const statistics = useMemo(() => {
    return normalizeStatistics(statsData);
  }, [statsData]);

  if (loading) {
    return (
      <div className="statistics-container">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className="statistics-container">
        <div className="error-message">Error: {error}</div>
      </div>
    );
  }

  // Mostrar estadísticas (si no hay datos, se mostrarán con valores en 0)
  return (
    <div className="statistics-container">
      <div className="statistics-content">
        {statistics.map((stat) => (
          <StatisticRow key={stat.key} stat={stat} />
        ))}
      </div>
    </div>
  );
}